import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar16Colors = {
  background?: string;
  hair?: string;
  skin?: string;
  accessories?: string;
};

export const Avatar16 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar16Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    hair: colors.hair ?? "#fff",
    skin: colors.skin ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar16">
        <G id="Group">
          <Path
            id="background"
            d="M151.834 303.667c83.855 0 151.833-67.979 151.833-151.834S235.689 0 151.834 0C67.978 0 0 67.978 0 151.833s67.978 151.834 151.834 151.834Z"
            fill={c.background}
          />
          <G id="Group_2">
            <Path
              id="hair"
              d="M84.511 133.531c-2.828-2.216-7.459-3.074-10.708-.27-6.307 5.449-2.295 13.48-2.295 13.48s-6.887-4.591-14.918 4.02c-8.031 8.603-5.45 14.918-5.45 14.918s-18.929 16.92-7.745 36.429c11.185 19.502 23.807 20.367 23.807 20.367s-1.144 12.337 12.337 13.481c13.48 1.143 15.49-6.602 15.49-6.602s.285 7.459 9.182 4.306c8.889-3.154 32.124-23.807 25.817-38.153 4.313 0 4.075 1.652 4.353.167 1.43-7.507-.898-24.665-.898-24.665-18.619-7.245-23.528-21.479-21.813-30.98l-24.934-2.192c.174 1.342-2.439-5.577-2.225-4.306Z"
              fill={c.hair}
            />
            <Path
              id="Vector"
              d="M139.727 242.827c-26.714-4.623-77.02 11.415-94.091 17.508 27.381 26.801 64.859 43.332 106.197 43.332 28.327 0 54.835-7.769 77.53-21.273-15.609-11.145-62.27-34.833-89.643-39.567h.007Z"
              fill="#000"
            />
            <Path
              id="skin"
              d="M177.658 58.847c-74.344 0-81.78 19.747-81.78 65.971 0 2.407-.412 1.509-.19 3.996-7.046 0-13.138 14.87-10.048 24.132 7.236 21.702 24.41 22.004 24.752 21.821 2.812 6.395-3.313 47.495-5.171 54.827-3.011 11.836-25.92 21.852-25.92 21.852s50.021 39.44 84.861 51.721a151.333 151.333 0 0 0 25.419-4.234c2.256-10.763-.318-29.343-3.066-33.045-3.916-5.275-10.501-3.622-14.68-10.946-1.771-3.114-.039-22.369.7-35.032 10.032-1.461 20.311 4.536 30.28-5.774 6.546-6.768 17.428-31.83 20.121-46.407 2.193-11.852-.993-14.155-.993-29.415 1.875-41.37-3.113-79.475-44.293-79.475l.008.008Z"
              fill={c.skin}
            />
            <Path
              id="Vector_2"
              d="M135.645 125.302s12.955-3.948 23.036-3.877c11.844.08 20.161 7.761 22.44 3.829.723-1.247.231-7.809-21.352-9.961-9.66-.962-15.339 3.423-24.124 10.009Z"
              fill="#000"
            />
            <Path
              id="Vector_3"
              d="M177.784 142.007c-2.923-4.838-7.761-9.294-13.838-10.374-2.74-.31-5.504-.008-8.11.969-2.129.786-3.773 2.097-5.354 3.4-2.145 1.43-4.981.889-7.554.596 2.43 1.652 6.029 2.97 8.992 1.556a25.1 25.1 0 0 1 2.057-1.159 5.375 5.375 0 0 0-.048.627c0 3.845 3.329 6.959 7.436 6.959 4.107 0 7.435-3.114 7.435-6.959 0-.318-.032-.619-.072-.929 2.916 1.295 5.847 3.209 9.064 5.314h-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_4"
              opacity={0.75}
              d="M199.82 127.63c-.278-.389-.278-1.016.087-1.771-10.152 14.116 3.869 36.818-1.597 41.1-3.82 2.987-18.262-1.192-18.826 2.637 5.259 3.217 19.74 5.783 24.125-1.652 1.716-3.837-9.636-29.383 1.62-40.322-2.137 1.47-4.464 1.311-5.401.016l-.008-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_5"
              opacity={0.75}
              d="M139.324 219.735c14.25 12.082 22.369 15.76 31.559 16.721-.166-7.085 1.661-16.896 1.256-17.031-20.264-6.95-29.082-13.313-45.533-27.373-5.99-5.124-11.375-12.519-16.006-19.271 0 .445.071.977 0 2.621 2.303 9.977 9.039 27.66 28.716 44.349l.008-.016Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_6"
              opacity={0.75}
              d="M164.121 182.941c.882.738 13.186 14.298 26.976 13.806 11.749-.421 15.546-11.574 15.824-12.138 0 0-5.187-4.814-8.801-4.679-3.607.127-6.133 1.851-6.133 1.851s-3.249-1.883-7.085-1.748c-3.837.135-7.245 2.074-10.836 2.661-3.63.588-9.953.247-9.953.247h.008Zm4.965 2.168c-.096-.047-.008-.159.103-.119 4.393 1.525 12.011 2.566 23.823 2.145 6.085-.215 10.104-.405 13.44-1.478-3.32 1.327-7.689 4.902-13.766 5.116-11.836.421-19.247-3.4-23.592-5.664h-.008Z"
              fill="#2E2017"
            />
            <Path
              id="Vector_7"
              d="M222.159 117.613c-14.156-.413-23.855 7.189-22.338 10.017.937 1.748 3.829 1.819 5.958-.151 5.838-4.853 10.374-3.233 16.499-3.312.135-2.002-.096-4.878-.119-6.546v-.008Z"
              fill="#000"
            />
            <Path
              id="Vector_8"
              d="M227.678 136.67c-1.581-1.311-3.217-2.614-5.354-3.4-2.606-.977-5.378-1.279-8.11-.969-6.077 1.08-10.923 5.536-13.838 10.374 1.652-1.08 3.233-2.113 4.766-3.034.286 3.384 3.297 6.045 6.983 6.045 3.868 0 7.014-2.939 7.014-6.562 0-1.231-.382-2.375-1.017-3.352 2.51.27 5.171 1.215 8.126 3.058 2.955 1.414 6.554.096 8.992-1.557-2.573.286-5.417.834-7.554-.595l-.008-.008Z"
              fill="#000"
            />
            <Path
              id="hair_2"
              d="M95.378 132.547c11.439-2.367 19.295 14.68 19.295 14.68l6.101-.508 2.033-24.403s6.45-2.653 12.154-9.548c-5.124-.858-8.5-1.74-8.5-1.74l-31.075 21.511-.008.008Z"
              fill={c.hair}
            />
            <G id="Group_3">
              <Path
                id="Vector_9"
                d="M259.198 112.29c-1.089.85-1.811 1.319-1.811 1.319.58-.27 1.191-.723 1.811-1.319Z"
                fill="#000"
              />
              <Path
                id="Vector_10"
                d="M254.114 82.716c-11.383-7.197-24.831-3.082-37.644 4.123.691.651 1.644 2.311 2.526 6.418 1.723 7.999 3.01 33.506 3.01 33.506s30.178-10.755 35.381-13.154c0 0 19.454-16.531-3.273-30.9v.007Z"
                fill="#000"
              />
              <Path
                id="accessories"
                d="M264.132 84.686c-14.735-15.054-44.111-10.43-44.111-10.43s-12.519-30.114-28.12-34.046c-15.601-3.932-39.202-11.415-61.158-1.184-21.956 10.231-55.692 18.334-44.317 99.144l43.126-27.016s35.436 8.618 53.158-1.724c8.849-5.164 20.995-15.41 33.768-22.584 12.813-7.205 26.262-11.32 37.645-4.123 22.726 14.37 3.272 30.901 3.272 30.901s.723-.469 1.812-1.319c4.845-3.805 16.967-15.315 4.933-27.612l-.008-.007Z"
                fill={c.accessories}
              />
            </G>
            <Path
              id="Vector_11"
              d="M195.786 76.146c-23.148 4.075-45.891 14.013-63.303 30.369a1805.841 1805.841 0 0 0-5.958-23.299c-.762-2.9-1.549-5.687-1.993-8.57-1.7-10.351-.096-23.649 3.399-33.57.072-.207-.222-.334-.309-.127-4.417 9.778-6.57 23.306-5.291 34.03.858 6.005 2.415 11.693 3.694 17.563 1.263 5.489 2.272 11.876 3.352 16.88.326 1.525 2.153 2.089 3.265 1.025 14.322-13.68 33.164-23.49 51.832-29.423 10.724-3.368 23.934-5.108 35.11-6.228.159-.016.143-.35-.015-.35-7.221.04-16.634.5-23.792 1.7h.009Z"
              fill="#000"
            />
            <Path
              id="Vector_12"
              d="M133.435 37.923c.659 1.597-9.5 5.958-10.16 4.353-.659-1.596 1.081-3.868 3.885-5.076 2.804-1.207 5.608-.882 6.267.715l.008.008Z"
              fill="#000"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
};
